import React, { useState } from 'react';
import classnames from 'classnames';
import { GenerateIcon, ICONS, Popover, PopoverContent, PopoverTrigger } from '@pileus-cloud/anodot-frontend-common';
import { PERMISSIONS_CATEGORIES } from 'users/containers/Organization/consts';

import styles from './PermissionsCategorySelection.module.scss';

const PermissionsCategorySelection = ({ selectedCategory, onCategorySelectionChanged }) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggle = () => {
    setIsOpen((prev) => !prev);
  };

  const customerClickedHandler = async (category) => {
    toggle();
    onCategorySelectionChanged(category);
  };

  return (
    <Popover open={isOpen} onOpenChange={toggle}>
      <PopoverTrigger>
        <div className={classnames(styles.categorySelection)}>
          <div className={styles.categoryText}>
            {`Category: `}
            <span className={styles.categoryName}>{selectedCategory.label}</span>
          </div>
          <GenerateIcon iconName={ICONS.caretDown.name} className={styles.caretDownIcon} />
        </div>
      </PopoverTrigger>
      <div className={styles.popoverWrapper}>
        <PopoverContent side="bottom" align="start" className={styles.popoverContent}>
          <div className={styles.menuContainer}>
            {Object.values(PERMISSIONS_CATEGORIES)?.map((category) => (
              <div
                key={category.id}
                onClick={() => customerClickedHandler(category)}
                className={classnames(styles.option, {
                  [styles.selected]: selectedCategory.id === category.id,
                })}
              >
                {category.label}
              </div>
            ))}
          </div>
        </PopoverContent>
      </div>
    </Popover>
  );
};

export default PermissionsCategorySelection;
